<template>
<div class="form-part">
  <div class="row">
    <div class="col-2 label-right mt-1">
      <label>File name</label>
    </div>
    <div class="col-4">
      <b-form-input v-model="fields.pulsar_file_name" class="file_name_input"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <NameResolver fields-prefix="pulsar" />
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <ToggleAllButton fields-prefix="pulsar" />
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.pulsar_date_obs_sel" class="mt-1">Obs date</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-input-group>
        <b-form-input v-model="fields.pulsar_date_obs_min" placeholder="yyyy-MM-dd"></b-form-input>
        <b-input-group-append>
          <VueCtkDateTimePicker v-model="fields.pulsar_date_obs_min" format="YYYY-MM-DD" :no-label="true" :only-date="true" :no-value-to-custom-elem="true" :right="true">
            <button type="button" class="btn btn-secondary">
              <font-awesome-icon icon="calendar-alt" />
            </button>
          </VueCtkDateTimePicker>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="fieldErrors.pulsar_date_obs_min">{{fieldErrors.pulsar_date_obs_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-input-group>
        <b-form-input v-model="fields.pulsar_date_obs_max" placeholder="yyyy-MM-dd"></b-form-input>
        <b-input-group-append>
          <VueCtkDateTimePicker v-model="fields.pulsar_date_obs_max" format="YYYY-MM-DD" :no-label="true" :only-date="true" :no-value-to-custom-elem="true" :right="true">
            <button type="button" class="btn btn-secondary">
              <font-awesome-icon icon="calendar-alt" />
            </button>
          </VueCtkDateTimePicker>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="fieldErrors.pulsar_date_obs_max">{{fieldErrors.pulsar_date_obs_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.pulsar_program_sel" class="mt-1">Project id</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.pulsar_program"></b-form-input>
    </div>
    <!--
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.pulsar_observer_sel" class="mt-1 ml-4">Observer</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.pulsar_observer"></b-form-input>
    </div>
    -->
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.pulsar_backend_sel" class="mt-1">Backend</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.pulsar_backend" multiple class="w-100">
        <option>PDFB3</option>
        <option>ROACH1</option>
      </b-form-select>
    </div>
  </div>

  <div class="row">
    <div class="col-3 mt-3 text-right">Frequency selection mode:</div>
    <div class="col-6">
      <b-form-radio-group label="Frequency selection mode" v-model="fields.pulsar_frequency_query_mode" v-slot="{ ariaPulsarFreqMode }" class="mt-3">
        <b-form-radio :aria-describedby="ariaPulsarFreqMode" name="pulsar_frequency_query_mode" value="FREE">Free range</b-form-radio>
        <b-form-radio :aria-describedby="ariaPulsarFreqMode" name="pulsar_frequency_query_mode" value="BAND">Band</b-form-radio>
      </b-form-radio-group>
    </div>
  </div>

  <div class="row" v-if="fields.pulsar_frequency_query_mode === 'FREE'">
    <div class="col-2">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.pulsar_freq_sel" class="mt-1">Frequency [MHz]</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.pulsar_freq_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.pulsar_freq_min">{{fieldErrors.pulsar_freq_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.pulsar_freq_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.pulsar_freq_max">{{fieldErrors.pulsar_freq_max}}</span>
    </div>
  </div>

  <div class="row" v-if="fields.pulsar_frequency_query_mode === 'BAND'">
    <div class="col-3">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.pulsar_freq_sel" class="mt-1 label-left">Frequency band</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.pulsar_freq" multiple class="w-100">
        <option value="300-360">P (300-360 MHz)</option>
        <option value="1300-1800">L (1300-1800 MHz)</option>
        <option value="5700-7700">C (5700-7700 MHz)</option>
        <option value="18000-26500">K (18000-26500 MHz)</option>
      </b-form-select>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.pulsar_obs_mode_sel" class="mt-1">Observation mode</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.pulsar_obs_mode" class="fit-width">
        <option :value="null">Select...</option>
        <option value="SRCH">SRCH</option>
        <option value="PSR">PSR</option>
        <option value="CAL">CAL</option>
      </b-form-select>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.pulsar_npol_sel" class="mt-3">No. of polarisations (NPOL)</b-form-checkbox>
    </div>
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.pulsar_nbits_sel" class="mt-3">No. of bits per sample (NBITS)</b-form-checkbox>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.pulsar_obsbw_sel" class="mt-1">Bandwidth [MHz]</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.pulsar_obsbw_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.pulsar_obsbw_min">{{fieldErrors.pulsar_obsbw_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.pulsar_obsbw_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.pulsar_obsbw_max">{{fieldErrors.pulsar_obsbw_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.pulsar_chan_bw_sel" class="mt-1">Spectral resolution [MHz]</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.pulsar_chan_bw_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.pulsar_chan_bw_min">{{fieldErrors.pulsar_chan_bw_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.pulsar_chan_bw_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.pulsar_chan_bw_max">{{fieldErrors.pulsar_chan_bw_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.pulsar_tbin_sel" class="mt-1">TBIN [s]</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.pulsar_tbin_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.pulsar_tbin_min">{{fieldErrors.pulsar_tbin_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.pulsar_tbin_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.pulsar_tbin_max">{{fieldErrors.pulsar_tbin_max}}</span>
    </div>
  </div>

</div>
</template>

<script>
import NameResolver from './RadioNameResolver.vue';
import ToggleAllButton from './ToggleAllButton.vue';
import {
  mapState
} from 'vuex';

export default {
  name: 'Pulsar',
  components: {
    NameResolver,
    ToggleAllButton
  },
  computed: mapState({
    fields: state => state.searchForm.fields,
    fieldErrors: state => state.searchForm.fieldErrors,
    toggleStatus: state => state.searchForm.toggleStatus['pulsar']
  })
}
</script>
